const ZERO_TRACE_ID = '00000000000000000000000000000000';
const ZERO_PARENT_ID = '0000000000000000';
const VERSION_00 = '00';
export function parseTraceparent(traceparent) {
    const parts = traceparent.split('-');
    if (parts.length !== 4) {
        return undefined;
    }
    const [version, traceId = '', parentId = '', traceFlags = ''] = parts;
    if (version !== VERSION_00) {
        return undefined;
    }
    if (!/^[\da-f]{32}$/iu.test(traceId) || traceId === ZERO_TRACE_ID) {
        return undefined;
    }
    if (!/^[\da-f]{16}$/iu.test(parentId) || parentId === ZERO_PARENT_ID) {
        return undefined;
    }
    if (!/^[\da-f]{2}$/iu.test(traceFlags)) {
        return undefined;
    }
    return { traceId, parentId, traceFlags };
}
